export default "__VITE_ASSET__CtcRWD6k__"